import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

/**
 * Replaces `page:notifications` from `@backstage/plugin-notifications` with a
 * Tailwind/shadcn page (ADR-0012). The stock page is Material-UI: a fixed
 * filter rail plus a dense `Table`, which neither matches the rest of the
 * portal nor collapses onto a phone.
 *
 * Aliasing the plugin's own route ref keeps `useRouteRef` call sites and the
 * `/notifications` sidebar entry pointing here, and `noHeader` suppresses the
 * `PluginHeader` the blueprint would otherwise stack above the page's own
 * branded `Header`.
 */
export const notificationsModule = createFrontendModule({
  pluginId: 'notifications',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/notifications',
        noHeader: true,
        routeRef: createRouteRef({ aliasFor: 'notifications.root' }),
        loader: () =>
          import('./VivictaNotificationsPage').then(m => (
            <PageErrorBoundary title="Notifications">
              <m.VivictaNotificationsPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
